import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Logo, GoldButton, Input } from "@/components/ui-kit";
import { GoogleButton } from "@/pages/Login";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { setUser } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/auth/login", { email, password });
      if (res.data.user.role !== "admin") {
        toast.error("This account is not an admin.");
        setLoading(false);
        return;
      }
      localStorage.setItem("cc_token", res.data.token);
      setUser(res.data.user);
      navigate("/admin", { replace: true });
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#060D1F] flex flex-col" data-testid="admin-login-page">
      <div className="px-5 sm:px-8 pt-6"><Logo /></div>
      <main className="flex-1 flex items-center justify-center px-5 py-14">
        <div className="w-full max-w-md fade-up">
          <p className="text-xs tracking-[0.3em] uppercase text-[#D4AF37]">Admin Portal</p>
          <h1 className="mt-3 text-3xl sm:text-4xl text-white tracking-tight">Team access only</h1>
          <form onSubmit={submit} className="mt-9 space-y-5" data-testid="admin-login-form">
            <Input data-testid="admin-email-input" label="Admin email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
            <Input data-testid="admin-password-input" label="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
            <GoldButton data-testid="admin-login-submit" type="submit" disabled={loading} className="w-full">
              {loading ? "Logging in..." : "Log in to Admin"}
            </GoldButton>
          </form>
          <div className="my-6 flex items-center gap-4">
            <div className="h-px flex-1 bg-white/10" /><span className="text-xs text-slate-500 uppercase tracking-widest">or</span><div className="h-px flex-1 bg-white/10" />
          </div>
          <GoogleButton testid="admin-google-login-button" />
        </div>
      </main>
    </div>
  );
}
